import {Inject, Injectable} from '@angular/core';
import {EntitiesChannel} from "../../../commons/angular/classes/entities-channel";
import {FulfillmentModel} from "../../models/fulfillment.model";

@Injectable({providedIn: 'root'})
export class FulfillmentChannelService extends EntitiesChannel<FulfillmentModel> {

  constructor(@Inject('firebaseService') protected firebaseService) {
    super()
  }

  getChannelName(): String {
    return "fulfillments_changed";
  }

  getPartialChannelName(): String {
    return "fulfillments_partial_changed";
  }

  getCreateChannelName(): String {
    return "";
  }

}
